module.exports = __webpack_public_path__ + "media/Loops Vocals.efdec3ee.wav";